import Template from "./template/Template";
import VueRouter from 'vue-router'
import Vue from "vue";
import Layout from "./template/components/Layout/Layout";
import layoutRoutes from "./routes/template/layout";
import LoginTemplate from "./template/pages/Login/Login";
import DocLayout from "./template/pages/Documentation/components/Layout/DocLayout";
import docLayoutRoutes from "./routes/template/docLayout";
import Main from "./main/Main";
import userLayoutRoutes from "./routes/main/userLayoutRoutes";
import UsersLayout from "./main/modules/User/components/Layout/UsersLayout";
import CompanyLayout from "./main/modules/Company/components/Layout/CompanyLayout";
import companyLayoutRoutes from "./routes/main/companyLayoutRoutes";
import Error_404 from "./template/pages/Error/404/Error_404";
import Error_500 from "./template/pages/Error/500/Error_500";
import Error_403 from "./template/pages/Error/403/Error_403";
import CalculationsLayout from "./main/modules/Calculations/components/Layout/CalculationsLayout"
import calculationsLayoutRoutes from "./routes/main/calculationsLayoutRoutes";
import ClientLayout from "./main/modules/Clients/components/Layout/ClientLayout";
import clientLayoutRoutes from "./routes/main/clientLayoutRoutes";
import ProductsLayout from "./main/modules/Products/components/Layout/ProductsLayout";
import productsLayoutRoutes from "./routes/main/productsLayoutRoutes";
import EmployeLayout from "./main/modules/Employees/components/Layout/EmployeLayout";
import employeLayoutRoutes from "./routes/main/employeLayoutRoutes";
import ProjectLayout from "./main/modules/Projects/components/Layout/ProjectLayout";
import projectLayoutRoutes from "./routes/main/projectLayoutRoutes";
import invoiceLayoutRoutes from "./routes/main/invoiceLayotRoutes";
import InvoiceLayout from "./main/modules/Invoices/components/Layout/InvoiceLayout";
import OfferLayout from "./main/modules/Offers/components/Layout/OfferLayout";
import offerLayoutRoutes from "./routes/main/offerLayoutRoutes";
import UsersListLayout from "./main/modules/Users/components/Layout/UsersListLayout";
import usersLayoutRoutes from "./routes/main/usersLayoutRoutes";
import subscriptionLayoutRoutes from "./routes/main/subscriptionLayoutRoutes";
import SubscriptionLayout from "./main/modules/UserSubscriptions/components/Layout/SubscriptionLayout";
import TranslationLayout from "./main/modules/Translations/components/Layout/TranslationLayout";
import translationsLayoutRoutes from "./routes/main/translationsLayoutRoutes";
import DashboardLayout from "./main/modules/Dashboard/components/layout/DashboardLayout";
import dashboardLayoutRoutes from "./routes/main/dashboardLayoutRoutes";
import preventDataLost from "./main/store/preventDataLost";
import layoutCompany from "./main/modules/Company/store/layoutCompany";
import profileLayoutRoutes from "./routes/main/profileLayoutRoutes";
import ProfileLayout from "./main/modules/Profile/components/Layout/ProfileLayout.vue";

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: "/template",
            component: Template,
            children: [
                {
                    path: "documentation",
                    name: "DocLayout",
                    component: DocLayout,
                    children: docLayoutRoutes,
                    redirect: { name: "Overview" }
                },
                {
                    path: "",
                    name: "Layout",
                    component: Layout,
                    children: layoutRoutes,
                    redirect: { name: "UserProfile" }
                },
                {
                    path: "login",
                    name: "LoginTemplate",
                    component: LoginTemplate
                },
            ]
        },
        {
            path: "",
            component: Main,
            children: [
                {
                    path: "dashboard",
                    name: "DashboardLayout",
                    component: DashboardLayout,
                    children: dashboardLayoutRoutes,
                },
                {
                    path: "user",
                    name: "UsersLayout",
                    component: UsersLayout,
                    children: userLayoutRoutes,
                    redirect: { name: "LoginMain" }
                },
                {
                    path: "calculations",
                    name: "CalculationsLayout",
                    component: CalculationsLayout,
                    children: calculationsLayoutRoutes
                },
                {
                    path: "companies",
                    name: "CompanyLayout",
                    component: CompanyLayout,
                    children: companyLayoutRoutes,
                },
                {
                    path: "clients",
                    name: "ClientLayout",
                    component: ClientLayout,
                    children: clientLayoutRoutes
                },
                {
                    path: "products",
                    name: "ProductsLayout",
                    component: ProductsLayout,
                    children: productsLayoutRoutes
                },
                {
                    path: "employees",
                    name: "EmployeeLayout",
                    component: EmployeLayout,
                    children: employeLayoutRoutes
                },
                {
                    path: "projects",
                    name: "ProjectLayout",
                    component: ProjectLayout,
                    children: projectLayoutRoutes
                },
                {
                    path: "invoices",
                    name: "InvoiceLayout",
                    component: InvoiceLayout,
                    children: invoiceLayoutRoutes,
                },
                {
                    path: "offers",
                    name: "OfferLayout",
                    component: OfferLayout,
                    children: offerLayoutRoutes
                },
                {
                    path: "users",
                    name: "UsersListLayout",
                    component: UsersListLayout,
                    children: usersLayoutRoutes,
                },
                {
                    path: "subscriptions",
                    name: "SubscriptionLayout",
                    component: SubscriptionLayout,
                    children: subscriptionLayoutRoutes
                },
                {
                    path: "profile",
                    name: "ProfileLayout",
                    component: ProfileLayout,
                    children: profileLayoutRoutes
                },
                {
                    path: "translations",
                    name: "TranslationsLayout",
                    component: TranslationLayout,
                    children: translationsLayoutRoutes
                },
            ]
        },
        {
            path: "/error/500",
            name: "Error_500",
            component: Error_500
        },
        {
            path: '/error/403',
            name: 'Error_403',
            component: Error_403
        },
        {
            path: '*',
            name: 'Error_404',
            component: Error_404
        }
    ],
});

router.beforeEach((to, from, next) => {

    if (preventDataLost.state.isDataChanged) {
        router.app.$store.dispatch('preventDataLost/updateIsModalVisible', true);
        router.app.$store.dispatch('preventDataLost/updateCurrentPath', to.path);
        return false
    }

    if (layoutCompany.state.drawer) {
        router.app.$store.dispatch('layoutCompany/TOGGLE_DRAWER');
    }

    if(window.localStorage.getItem("tokenAuth") && to.path === '/'){
        return next({ name: "MyCompany" });
    } else if (!window.localStorage.getItem("tokenAuth") && to.path === '/') {
        return next({ name: "LoginMain" });
    }

    if(!to.meta.isAuth && !to.meta.isGuest) {
        return next();
    }

    if(to.meta.isGuest && window.localStorage.getItem("tokenAuth")) {
        return next({ name: "MyCompany" });
    } else if(to.meta.isGuest) {
        return next();
    }

    if(window.localStorage.getItem("tokenAuth")) {
        next();
    } else {
        next({ name: "LoginMain" });
    }

    if(window.localStorage.getItem("isSubscribing") === 'true') {
        next();
    } else {
        if(to.query.checkPayment === 'true') {
            next({ path: "/subscriptions", query: {checkPayment: true} })
        } else {
            next({ path: "/subscriptions" })
        }
    }
    
    if (window.localStorage.getItem("companyIsVatPayer") === 'null' && to.name !== 'MyCompany') {
        if (from.name !== 'MyCompany') {
            next({ name: "MyCompany" });
        } else {
            next({ name: "MyCompany" });
            router.app.$store.dispatch('incompleteProfile/updateIsIncompleteProfileModallVisible', true); 
        }    
    }

});

export default router